// import {loadPage} from '@/helpers/routing'

/**
 * screen a f7 alert on error.
 *
 * @param {Error} error - an error.
 * @param {Vue} element - the vue component.
 */
export const errorMessageAlert = (error, element) => {
  let that = element
  that.$f7.hidePreloader()
  if (error.response) {
    switch (error.response.status) {
      case 400:
        if (error.response.data) {
          if (error.response.data.error && error.response.data.errorDescription) {
            that.$f7.alert(error.response.data.errorDescription, error.response.data.error)
          } else if (error.response.data.statusText) {
            that.$f7.alert('', error.response.data.statusText)
          } else if (error.response.data.errors) {
            /** @author TLV 26/01/2021
            * @brief Ajout de la gestion de multiples erreurs retournées par la modé
            * @details Besoin d'ajouter les traductions une par une pour que la modé puisse
            *         fonctionner indépendamment de l'ihm
            */
            error.response.data.errors.map(err => {
              var titleError = err.error
              var descError = err.errorDescription
              if (err.errorDescription === 'Siren key parameter is invalid') {
                that.$f7.alert(that.$i18n.t('errors.invalid_siren'), that.$i18n.t('errors.invalid_param'))
              } else {
                 /** @author FJE 03/02/2021
                * @brief Ajout de la vérification que la traduction d'une erreur existe ou retour de l'erreur retourné par la modélisation
                * @details Besoin d'ajouter les traductions une par une et retour de l'erreur retournée par la modé pour que l'erreur puisse
                *         être remontée indépendamment de l'ihm
                */
                titleError = titleError.replace(/\s/g, '_')
                descError = descError.replace(/\s/g, '_')
                if ((that.$i18n.t('errors.' + descError).localeCompare('errors.' + descError) === '0' && that.$i18n.t('errors.' + titleError).localeCompare('errors.' + titleError) === '0')) {
                  that.$f7.alert(that.$i18n.t('errors.' + descError), that.$i18n.t('errors.' + titleError))
                } else {
                  that.$f7.alert(err.errorDescription, err.error)
                }
              }
            })
          }
        } else {
          that.$f7.alert('', error.response.statusText)
        }
        break
      case 401:

        // that.$f7.alert('Please Log in again', 'Session finished')
        that.$bus.$emit('logout', true)
        break
      case 406:
        that.$f7.alert('Please, try to connect again', 'Session Failed')
        break
      case 409:
        that.$f7.alert('You will receive a new code', 'Code Expired')
        break
      case 424:
        that.$f7.alert('Please follow the activation link provided via email', 'Activation failed')
        break
      default:
        that.$f7.alert(error.response.data.errorDescription, error.response.data.error)
    }
  } else {
    that.$f7.alert('We will get it fixed as soon as we can.', 'Something went wrong with the Network')
    console.log(error, element)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/alert.js